/**
 * Button with styling specific to PoiDialog and PoiGroupDialog
 */
export const PoiDialogButton = ({
    text,
    variant = "primary",
    type = "button",
    onClick,
    className = "",
    disabled = false
}) => {

    const variantStyles = {
        primary: "bg-blue-500 hover:bg-blue-600 text-white",
        danger: "bg-red-600 hover:bg-red-700 text-white",
        success: "bg-emerald-500 hover:bg-emerald-600 text-white",
        cancel: "bg-gray-500 hover:bg-gray-600 text-white",
    };

    // combine variant styles with any custom classes passed
    const styles = `${variantStyles[variant]} text-white font-bold py-2 px-4 rounded shadow-md focus:outline-none focus:ring-2 transition-all duration-300 ${className}`;

    return(
        <button
            type={type}
            className={styles}
            disabled={disabled}
            onClick={onClick || null}
        >
            {text}
        </button>

    )
}